module.exports = __webpack_public_path__ + "static/media/blessedsacrament.97ed0343.webp";